import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';

import { setSource } from './newsfeed-results.actions';
import { NewsfeedContentSource } from './newsfeed-results.models';
import {
  getIsLoaded,
  getIsLoadingMore,
  getNextCursor,
  getResults,
  getResultsCount,
  getResultsTotalAmount,
  getSource,
} from './newsfeed-results.selectors';

@Injectable()
export class NewsfeedResultsFacade {
  source$ = this.store.pipe(select(getSource));
  isLoaded$ = this.store.pipe(select(getIsLoaded));
  isLoadingMore$ = this.store.pipe(select(getIsLoadingMore));
  results$ = this.store.pipe(select(getResults));
  resultsCount$ = this.store.pipe(select(getResultsCount));
  moreAvailable$ = combineLatest([
    this.store.pipe(select(getResultsTotalAmount)),
    this.store.pipe(select(getResultsCount)),
    this.store.pipe(select(getNextCursor)),
  ]).pipe(
    map(([overallCount, count, cursor]) => cursor !== undefined || (overallCount !== undefined && overallCount > count))
  );

  constructor(private readonly store: Store) {}

  setSource(source: NewsfeedContentSource): void {
    this.store.dispatch(setSource({ source }));
  }
}
